import { toast } from 'react-toastify'

// Generate a consistent toastId from message to prevent duplicates
const getToastId = (type: string, message: string): string => {
  // Create a consistent ID from type and message
  const normalizedMessage = message.slice(0, 50).replace(/\s+/g, '-').toLowerCase()
  return `toast-${type}-${normalizedMessage}`
}

export const toastSuccess = (message: string) => {
  const toastId = getToastId('success', message)

  toast.success(message, {
    toastId,
  })
}

export const toastError = (message: string) => {
  const toastId = getToastId('error', message)

  toast.error(message, {
    toastId,
  })
}

export const toastInfo = (message: string) => {
  const toastId = getToastId('info', message)

  toast.info(message, {
    toastId,
  })
}

export const toastWarning = (message: string) => {
  const toastId = getToastId('warning', message)

  toast.warning(message, {
    toastId,
  })
}
